module.exports = __webpack_public_path__ + "media/images/employees/tonka-94a16f888bdc769755074260d5130afc.png";